import React from 'react';
import { Button } from 'reactstrap';
import classNames from 'classnames';
import propTypes from 'prop-types';
import { Toolbars as ToolBarContainer } from '../../../../components/Card/CardHeaderWithToolbars';

const Toolbars = props => {
  const { isOpen, isLoading, filterPanelId } = props;
  const toggleLabel = isOpen ? 'Hide filters' : 'Show filters';

  return (
    <ToolBarContainer>
      <Button
        type="button"
        title="Refresh"
        aria-label="Refresh"
        color="info"
        size="sm"
        className="with-toolbars__toolbars__btn"
        disabled={isLoading}
        onClick={props.onRefreshList}
      >
        <i className="fa fa-refresh" aria-hidden="true"></i>
      </Button>
      <Button
        type="button"
        title="Reset filter"
        aria-label="Reset filter"
        color="warning"
        size="sm"
        className="with-toolbars__toolbars__btn"
        disabled={isLoading}
        onClick={props.onResetFilter}
      >
        <i className="fa fa-ban" aria-hidden="true"></i>
      </Button>
      <Button
        type="button"
        title={toggleLabel}
        aria-label={toggleLabel}
        aria-expanded={isOpen}
        aria-controls={filterPanelId}
        size="sm"
        className={classNames('with-toolbars__toolbars__btn', { 'btn-danger': isOpen })}
        onClick={props.onToggleFilter}
      >
        <i className={classNames('fa', { 'fa-sliders': !isOpen, 'fa-minus': isOpen })} aria-hidden="true"></i>
      </Button>
    </ToolBarContainer>
  );
};

Toolbars.propTypes = {
  isOpen: propTypes.bool,
  isLoading: propTypes.bool,
  filterPanelId: propTypes.string,
  onToggleFilter: propTypes.func,
  onResetFilter: propTypes.func,
  onRefreshList: propTypes.func
};

Toolbars.defaultProps = {
  isOpen: false,
  isLoading: false
};

export default Toolbars;
